var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-center q-mt-lg",style:('row-gap: 24px')},_vm._l((_vm.visiblePlans),function(card,idx){return _c('div',{key:("plan-" + idx),class:{
      'col-12 col-sm-6 col-md-4 q-px-12': true,
      'q-mt-md': _vm.$q.screen.lt.md
    }},[_c('plan-card',{staticClass:"full-height",attrs:{"plan-card":card,"active":card.id == _vm.activePlan,"current-plan":card.id == _vm.planId},on:{"select":_vm.onSelect}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }